var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hello screen-spacing" },
    [
      _c("div", {}, [
        _c("div", { staticClass: "h1 display-inline" }, [_vm._v("Stage List")]),
        _vm.venueId != 0 && _vm.isBusiness
          ? _c(
              "button",
              {
                ref: "action",
                staticClass: "btn mb-3",
                attrs: {
                  type: "button",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#newStageModal",
                },
              },
              [_c("i", { staticClass: "fa-solid fa-plus" })]
            )
          : _vm._e(),
      ]),
      _c("SelectVenue", {
        ref: "venueDropDown",
        on: { updateVenue: _vm.updateVenue },
      }),
      _c(
        "div",
        { staticClass: "row mt-4" },
        _vm._l(_vm.stageList, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "card m-3",
              staticStyle: { width: "18rem" },
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c("h5", { staticClass: "card-title mt-1" }, [
                  _vm._v(_vm._s(item.name)),
                ]),
                _c("h6", { staticClass: "card-sub-title text-muted mt-1" }, [
                  _vm._v(_vm._s(item.description)),
                ]),
                _c("h6", { staticClass: "card-sub-title text-muted mt-1" }, [
                  _vm._v(_vm._s(item.act_length)),
                ]),
                _c(
                  "div",
                  { staticClass: "btn-group", attrs: { role: "group" } },
                  [
                    item.is_disabled
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary mx-1",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleEnabled(item)
                              },
                            },
                          },
                          [_vm._v("Disabled")]
                        )
                      : _vm._e(),
                    !item.is_disabled
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary mx-1",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleEnabled(item)
                              },
                            },
                          },
                          [_vm._v("Enabled")]
                        )
                      : _vm._e(),
                    _vm.isBusiness
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary mx-1",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.openModal(item)
                              },
                            },
                          },
                          [_vm._v("Edit")]
                        )
                      : _vm._e(),
                    _vm.isBusiness
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary mx-1",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteStage(item._id, index)
                              },
                            },
                          },
                          [_vm._v("Delete")]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _c(
                "div",
                { staticClass: "card-footer text-center border-top bg-white" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-outline-secondary btn-sm",
                      attrs: {
                        to: {
                          name: "Performer-List",
                          query: { stage_ID: item._id, stageName: item.name },
                        },
                      },
                    },
                    [_vm._v(" See current performers ")]
                  ),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
      _c(
        "div",
        {
          ref: "modal",
          staticClass: "modal fade",
          attrs: {
            id: "newStageModal",
            tabindex: "-1",
            "aria-labelledby": "newStageModalLabel",
            "aria-hidden": "true",
          },
        },
        [
          _c("AddNewStage", {
            attrs: { stage: _vm.currentStage, venueId: _vm.venueId },
            on: {
              addNewStage: _vm.addNewStage,
              refreshEdit: _vm.refreshEdit,
              updateStage: _vm.updateStage,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }